import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const MobilePhonePackageIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M30.1 48.6H13.6c-2.2 0-4-1.8-4-4V5.2c0-2.2 1.8-4 4-4h16.5c2.2 0 4 1.8 4 4v39.4c0 2.2-1.8 4-4 4z"
        fill="#ffffff"
        stroke="#000000"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M30.9 7.2v31.6H13.2V7.2h17.7m1-1H12.2v33.6h19.7V6.2zM24.3 4.2h-4.7c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h4.7c.2 0 .4.2.4.4-.1.3-.2.4-.4.4zM22.2 42.9c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2S21 44.7 21 44s.5-1.1 1.2-1.1m0-1c-1.2 0-2.2 1-2.2 2.2s1 2.2 2.2 2.2 2.2-1 2.2-2.2-1-2.2-2.2-2.2z"
        fill="#000000"
        className={styles.defaultColor}
      />
      <path
        d="M28.6 14.1h9.1c.5 0 1 .2 1.4.6l2.1 2.2c.3.3.5.8.5 1.3v15.7c0 1-.8 1.9-1.9 1.9H28.6c-1 0-1.9-.8-1.9-1.9V16c0-1.1.9-1.9 1.9-1.9z"
        fill="#ffffff"
        stroke="#000000"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M37.1 33.4h-6c-1.1 0-2-.9-2-2v-6c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v6c.1 1.1-.8 2-2 2z"
        fill="#E81C30"
        className={styles.accentColor}
      />
      <path
        d="M29.1 26.8h10.1"
        fill="none"
        className={styles.whiteStroke}
        stroke="#fffff"
        strokeMiterlimit="10"
        strokeWidth=".5"
      />
      <path
        d="M31.5 30h7.7"
        fill="none"
        className={styles.whiteStroke}
        stroke="#fffff"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth=".5"
      />
      <path
        d="M31.7 23.4v3.4M34.2 23.4v3.4M36.7 23.4v3.4M36.7 30v3.4M34.2 30v3.4"
        fill="none"
        className={styles.whiteStroke}
        stroke="#fffff"
        strokeMiterlimit="10"
        strokeWidth=".5"
      />
      <path
        d="M31.5 30v3.4"
        fill="none"
        className={styles.whiteStroke}
        stroke="#fffff"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth=".5"
      />
    </Icon>
  )
}
